import React, { useState } from 'react';
import footerBg from '../../assets/footer-bg.png';
import '../../styles/Footer.css';

export default function Footer({ hasBottomSpacer = false }) {
  const [activeMenu, setActiveMenu] = useState(null);

  const toggleMobileMenu = (menuId) => {
    setActiveMenu(activeMenu === menuId ? null : menuId);
  };

  const handleNav = (hash) => {
    window.location.hash = hash;
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className={`real-footer-container ${hasBottomSpacer ? 'footer-with-bottom-spacer' : ''}`}>
      <div 
        className="footer-upper-blue-bg"
        style={{ backgroundImage: `url(${footerBg})` }}
      >
        <div className="footer-max-content-width">
          <div className="footer-art-spacer-left" />

          <div className="footer-links-layout-grid">
            
            
            <div className={`footer-link-col ${activeMenu === 'explore' ? 'is-mobile-open' : ''}`}>
              <h4 className="footer-col-title" onClick={() => toggleMobileMenu('explore')}>
                EXPLORE
                <span className="footer-mobile-chevron">▼</span>
              </h4>
              <ul className="footer-ul-links">
                <li><a href="#courses" onClick={() => handleNav('#courses')}>All Courses</a></li>
                <li><a href="#stories" onClick={() => handleNav('#stories')}>Success Stories</a></li>
                <li><a href="#blog" onClick={() => handleNav('#blog')}>Our Blog</a></li>
                <li><a href="#about" onClick={() => handleNav('#about')}>About Us</a></li>
              </ul>
            </div>

            
            <div className={`footer-link-col we-accept-column ${activeMenu === 'accept' ? 'is-mobile-open' : ''}`}>
              <h4 className="footer-col-title" onClick={() => toggleMobileMenu('accept')}>
                WE ACCEPT
                <span className="footer-mobile-chevron">▼</span>
              </h4>
              <div className="footer-mobile-collapsible-wrapper accept-content-box">
                <div className="payment-badges-card">
                  <div className="payment-tile visa">VISA</div>
                  <div className="payment-tile mastercard">
                    <span className="mc-circle red"></span>
                    <span className="mc-circle orange"></span>
                  </div>
                  <div className="payment-tile rupay">RuPay</div>
                  <div className="payment-tile upi">
                    <span>UPI</span>
                  </div>
                  <div className="payment-tile gpay">
                    <span className="g-b">G</span><span className="g-pay">Pay</span>
                  </div>
                  <div className="payment-tile phonepe">
                    <span className="pe-sym">पे</span>
                  </div>
                </div>

                <div className="secure-badge-pill">
                  <span className="lock-icon">🔒</span>
                  <span>100% Safe & 256-Bit Encrypted</span>
                </div>
              </div>
            </div>

            
            <div className={`footer-link-col ${activeMenu === 'support' ? 'is-mobile-open' : ''}`}>
              <h4 className="footer-col-title" onClick={() => toggleMobileMenu('support')}>
                SUPPORT
                <span className="footer-mobile-chevron">▼</span>
              </h4>
              <ul className="footer-ul-links">
                <li><a href="#faq" onClick={() => handleNav('#faq')}>FAQs</a></li>
                <li><a href="#terms-and-conditions" onClick={() => handleNav('#terms-and-conditions')}>Terms & Conditions</a></li>
                <li><a href="#privacy-policy" onClick={() => handleNav('#privacy-policy')}>Privacy Policy</a></li>
                <li><a href="#refund-policy" onClick={() => handleNav('#refund-policy')}>Refund Policy</a></li>
              </ul>
            </div>

           
            <div className={`footer-link-col contact-col-gap ${activeMenu === 'contact' ? 'is-mobile-open' : ''}`}>
              <h4 className="footer-col-title" onClick={() => toggleMobileMenu('contact')}>
                CONTACT US
                <span className="footer-mobile-chevron">▼</span>
              </h4>
              <div className="footer-mobile-collapsible-wrapper">
                <div className="contact-info-row">
                  <span className="contact-pink-icon">📞</span>
                  <span>+91 98765 43210</span>
                </div>
                <div className="contact-info-row">
                  <span className="contact-pink-icon">✉️</span>
                  <span>hello@creatorsdost.com</span>
                </div>
              </div>
            </div>

          </div>

          <div className="footer-art-spacer-right" />
        </div>
      </div>

      
      <div className="footer-bottom-dark-bar">
        <div className="footer-max-content-width bottom-bar-flex">
          <p className="copyright-text-label">
            © 2026 Creators Dost. All rights reserved.
          </p>

          <div className="footer-bar-divider" />

          <div className="value-promises-inline-strip">
            <div className="promise-item-node">
              <span className="promise-vector-icon">🎓</span>
              <span className="promise-text-label">Secure Payment</span>
            </div>
            
            <div className="footer-bar-divider" />

            <div className="promise-item-node">
              <span className="promise-vector-icon gold-star">★</span>
              <span className="promise-text-label">Trusted by <strong className="bold-gold-nums">50,000+</strong> Learners</span>
            </div>
            
            <div className="footer-bar-divider" />

            <div className="promise-item-node">
              <span className="promise-vector-icon">🧿</span>
              <span className="promise-text-label">Lifetime Access</span>
            </div>
            
            <div className="footer-bar-divider" />

            <div className="promise-item-node">
              <span className="promise-vector-icon">💻</span>
              <span className="promise-text-label">Access on All Devices</span>
            </div>
            
            <div className="footer-bar-divider" />

            <a 
              href="https://clickbydigital.com/" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="promise-item-node promise-link-node"
            >
              <span className="promise-vector-icon">🔄</span>
              <span className="promise-text-label">Developed by ClickByDigital</span>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}